module.exports = __webpack_public_path__ + "img/guidepage.48d9c662.png";